import React from 'react';
import SettingEmailForm from './components/SettingEmailForm';
import { useTranslation } from 'react-i18next';

const ChangeEmailPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.Users.ChangeEmailPage.change_email')}</h1>
      </div>
      <div>
        <SettingEmailForm />
      </div>
    </div>
  );
};

export default ChangeEmailPage;
